import * as React from "react";

import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";

import Typography from "@mui/material/Typography";

import { LISTA_MENU } from "../constants/constants";
import { CardActionArea } from "@mui/material";
import { ASSET_IMAGES } from "app/utils/constants/paths";

const DetalleMenuMobile = ({ datosBusqueda, setDatosBusqueda }) => {
  const handleItemTransaccional = (id) => {
    setDatosBusqueda((args) => ({
      ...args,
      idMovimiento: id,
      menuMobile: false,
    }));
  };

  const specialCardStyles = (item) => {
    if (item.id === 9) {
      return {
        background: "linear-gradient(to top right, #ee261f, #ee8b83, #ffff)",
        textColor: "black",
        position: "relative",
      };
    } else {
      return { position: "relative" };
    }
  };

  return (
    <>
      <div className="movimientoClienteMobile-container">
        <>
          {Number(datosBusqueda.idGrupo) === 1 ? (
            <img
              style={{ width: "auto", height: "10vh" }}
              src="/images/logo/logo-corpfav.png"
              alt="logo-copfav"
              loading="lazy"
            />
          ) : Number(datosBusqueda.idGrupo) === 2 ? (
            <img
              style={{ width: "auto", height: "11.5vh" }}
              src="/images/logo/logo-corpfav.png"
              alt="logo-copfav"
              loading="lazy"
            />
          ) : Number(datosBusqueda.idGrupo) === 3 ? (
            <img
              style={{ width: "auto", height: "11.5vh" }}
              src="/images/logo/logo-tvtas.png"
              alt="logo-copfav"
              loading="lazy"
            />
          ) : Number(datosBusqueda.idGrupo) === 4 ? (
            <img
              style={{ width: "auto", height: "11.5vh" }}
              src="/images/logo/logo-corpfav.png"
              alt="logo-copfav"
              loading="lazy"
            />
          ) : (
            <img
              style={{ width: "auto", height: "11.5vh" }}
              src="/images/logo/logo-corpfav.png"
              alt="logo-copfav"
              loading="lazy"
            />
          )}
        </>
      </div>
      <div className="movimientoClienteMobile-item">
        {LISTA_MENU.map((item) => (
          <Card sx={specialCardStyles(item)} key={item.id}>
            {item.id === 9 && (
              <img
                className="movimientoClienteMobile-logo-credi"
                src={`${ASSET_IMAGES}/Credi-2.png`}
                alt="Credi-Pague"
              />
            )}

            <CardActionArea onClick={() => handleItemTransaccional(item.id)}>
              <CardMedia
                sx={{
                  margin: "1.5rem 0 0 0",
                  display: "flex",
                  justifyContent: "center",
                  position: "relative",
                  overflow: "hidden",
                  height: "4rem",
                }}
              >
                {item.id === 9 ? (
                  <>
                    {/* 
                    <img
                      style={{ width: "100px", position: "absolute" }}
                      src={`${ASSET_IMAGES}/Credi-2.png`}
                      alt=""
                    /> */}
                  </>
                ) : (
                  <div
                    style={{
                      width: "4rem",
                      backgroundColor: "#feebe9",
                      borderRadius: "50%",
                      padding: "1rem",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <>{item.iconMenu}</>
                  </div>
                )}
              </CardMedia>

              {/*  <CardMedia
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  margin: "2rem 0 0 0",
                }}
              >
                <div
                  style={{
                    backgroundColor: "#feebe9",
                    borderRadius: "50%",
                    padding: "1rem",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                 
                </div>
              </CardMedia> */}

              <CardContent
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  padding: "1rem",
                }}
              >
                <h3 style={{ color: "black", fontFamily: "montserrat" }}>
                  {item.name}
                </h3>
              </CardContent>
            </CardActionArea>
          </Card>
        ))}
      </div>
    </>
  );
};

export default DetalleMenuMobile;
